import type { LegalDocId } from '@/data/legal';

/**
 * Legal-page hash routing (29 JUN 2026). Legal pages live ABOVE the auth gate
 * (see App.tsx · LegalGate), so they open whether or not the visitor is signed
 * in, and are deep-linkable / shareable. Hashes: #/terms #/privacy #/cookies
 * #/consent. parseCourseHash already returns null for these heads, so the
 * course router never fights for them.
 */

const SLUGS: readonly LegalDocId[] = ['terms', 'privacy', 'cookies', 'consent'];

/** Parse a URL hash into a legal doc id, or null if it is not a legal route. */
export function parseLegalHash(hash: string): LegalDocId | null {
  if (!hash || !hash.startsWith('#/')) return null;
  const head = hash.slice(2).split(/[/?]/)[0] ?? '';
  return (SLUGS as readonly string[]).includes(head) ? (head as LegalDocId) : null;
}

/** Build the hash for a legal doc. */
export function legalHash(id: LegalDocId): string {
  return `#/${id}`;
}
